import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useI18n } from '../context/I18nContext';

export default function GoogleAnalytics() {
  const { meta } = useI18n();
  const location = useLocation();
  const settings = meta?.settings || {};

  const gaId = settings.google_analytics_id ? settings.google_analytics_id.trim() : '';
  const gtmId = settings.google_tag_manager_id ? settings.google_tag_manager_id.trim() : '';

  // Inject Google Tag Manager / Analytics scripts dynamically
  useEffect(() => {
    if (gaId) {
      const scriptId = 'ga-gtag-script';
      if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
        document.head.appendChild(script);

        const inlineScript = document.createElement('script');
        inlineScript.id = 'ga-gtag-init';
        inlineScript.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaId}', { page_path: window.location.pathname });
        `;
        document.head.appendChild(inlineScript);
      }
    }

    if (gtmId) {
      const gtmScriptId = 'gtm-script';
      if (!document.getElementById(gtmScriptId)) {
        const script = document.createElement('script');
        script.id = gtmScriptId;
        script.innerHTML = `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/googletagmanager.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtmId}');
        `;
        document.head.appendChild(script);
      }
    }
  }, [gaId, gtmId]);

  // Track page views on route change
  useEffect(() => {
    if (gaId && typeof window.gtag === 'function') {
      window.gtag('config', gaId, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location, gaId]);

  return null;
}
